module.exports = __webpack_public_path__ + "img/pulih-logo-login.36d7c576.png";